/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;
      this.countDownDate = new Date(date_string).getTime();
    }

    connectedCallback() {
      const daysEl = this.querySelector('.days');
      const daysNum = this.querySelector('.days .countdown-timer--column--number');
      const hoursEl = this.querySelector('.hours .countdown-timer--column--number');
      const minutesEl = this.querySelector('.minutes .countdown-timer--column--number');
      const secondsEl = this.querySelector('.seconds .countdown-timer--column--number');

      // 👉 new: find any separator element (like the ":" before hours)
      const firstSeparator = daysEl?.nextElementSibling;
      const isSeparator = firstSeparator && firstSeparator.textContent.trim() === ':';

      const updateTime = () => {
        const now = Date.now();
        const distance = this.countDownDate - now;

        if (distance < 0) {
          [daysNum, hoursEl, minutesEl, secondsEl].forEach(el => el.textContent = '00');
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // 💡 If less than 24h → hide days + mark timer with a CSS class
        if (distance <= 24 * 60 * 60 * 1000) {
          daysEl.style.display = 'none';
          this.classList.add('no-days');
        } else {
          daysEl.style.display = '';
          this.classList.remove('no-days');
        }

        daysNum.textContent = CountdownTimer.addZero(days);
        hoursEl.textContent = CountdownTimer.addZero(hours);
        minutesEl.textContent = CountdownTimer.addZero(minutes);
        secondsEl.textContent = CountdownTimer.addZero(seconds);

        requestAnimationFrame(updateTime);
      };

      requestAnimationFrame(updateTime);
    }

    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
